import { render, staticRenderFns } from "./SellerOffers.vue?vue&type=template&id=f48f54fc&scoped=true"
import script from "./SellerOffers.vue?vue&type=script&lang=js"
export * from "./SellerOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48f54fc",
  null
  
)

export default component.exports